import { render, staticRenderFns } from "./collectorSelect.vue?vue&type=template&id=655df11e&scoped=true"
import script from "./collectorSelect.vue?vue&type=script&lang=js"
export * from "./collectorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655df11e",
  null
  
)

export default component.exports